import { Children, ReactNode, isValidElement } from 'react';
import { ScreenHeader } from '../../ScreenHeader/ScreenHeader';
import { DetailsPanel } from '../components/DetailsPanel';
import { ObjectContent } from '../components/ObjectContent';
import { ObjectDefaultLayout } from '../components/ObjectDefaultLayout';
import { ObjectSlot } from '../components/ObjectSlot';
import { ObjectStickyLayout } from '../components/ObjectStickyLayout';
import { ObjectStickyToolbar } from '../components/ObjectStickyToolbar';
import { ObjectTabs } from '../components/ObjectTabs/ObjectTabs';
import { ObjectSlotName, ObjectSlotProps } from '../objectScreen.types';

const findChild = (children: ReactNode, type: unknown) =>
  Children.toArray(children).find((child) => isValidElement(child) && child.type === type);

const findSlots = (children: ReactNode, name: ObjectSlotName) =>
  Children.toArray(children).filter(
    (child) =>
      isValidElement<ObjectSlotProps>(child) &&
      child.type === ObjectSlot &&
      child.props.name === name,
  );

export const useObjectScreenLayout = (children: ReactNode) => {
  const stickyWrapper = findChild(children, ObjectStickyToolbar);
  const pieces = isValidElement<{ children: ReactNode }>(stickyWrapper)
    ? stickyWrapper.props.children
    : children;

  return {
    header: findChild(pieces, ScreenHeader),
    tabs: findChild(pieces, ObjectTabs),
    content: findChild(pieces, ObjectContent),
    panel: findChild(pieces, DetailsPanel),
    afterHeaderSlots: findSlots(pieces, 'afterHeader'),
    afterToolbarSlots: findSlots(pieces, 'afterToolbar'),
    afterFilterBarSlots: findSlots(pieces, 'afterFilterBar'),
    Layout: stickyWrapper ? ObjectStickyLayout : ObjectDefaultLayout,
  };
};
